import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/provider/common.service';
declare var $:any
@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css']
})
export class ForgetPasswordComponent implements OnInit {
  forgetform: FormGroup;
  otp:number

  constructor(private router: Router, public commonService: CommonService) { }

  ngOnInit(): void {
    this.forgetform = new FormGroup({
      email: new FormControl('', Validators.compose([Validators.required, Validators.email, Validators.pattern(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,7}|[0-9]{1,3})(\]?)$/i)]))
    })
  }
  // ----------verify email on click -------------//
  verfyEmail(){
  let apiReqData={
    'emailUserName':this.forgetform.value.email
  }
  var apiReqUrl="admin/forgotPassword"
  this.commonService.showSpinner()
  this.commonService.postApi(apiReqUrl,apiReqData,0).subscribe((res:any)=>{
    if(res.responseCode==200)
    {
      this.commonService.hideSpinner()
      this.commonService.successToast(res.responseMessage)
      this.openModal()
      localStorage.setItem('email',btoa(this.forgetform.value.email))
    }
    else{
      this.commonService.hideSpinner()
      this.commonService.errorToast(res.responseMessage)
    }
  })
  }
// -------- verify Otp of forget password -----------//
  verfyOtp(){
    let apiReqData={
      'email':this.forgetform.value.email,
      'otp':this.otp
    }
    var apiReqUrl="admin/verifyOTP"
    this.commonService.showSpinner()
    this.commonService.postApi(apiReqUrl,apiReqData,0).subscribe((res:any)=>{
      if(res.responseCode==200)
      {
        this.commonService.hideSpinner()
        this.hideModal()
        this.router.navigate(['/reset-password'])
        this.commonService.successToast(res.responseMessage)
      }
      else{
        this.commonService.hideSpinner()
        this.commonService.errorToast(res.responseMessage)
      }
    })
    }

  // --------resend otp-------------//
  resendOtp(){
    let apiReqData={
      'email':this.forgetform.value.email,
    }
    var apiReqUrl="admin/resendOtp"
    this.commonService.showSpinner()
    this.commonService.postApi(apiReqUrl,apiReqData,0).subscribe((res:any)=>{
      if(res.responseCode==200)
      {
        this.commonService.hideSpinner()
        this.openModal()
        this.commonService.successToast(res.responseMessage)
      }
      else{
        this.commonService.hideSpinner()
        this.commonService.errorToast(res.responseMessage)
      }
    })
    }

  onOtpChange(e) {
    this.otp = e;
  }
  
  // to hide modal
  hideModal(){
    $('#exampleModal').modal('hide')
  }
  // to open modal  
  openModal(){
    $('#exampleModal').modal('show')
  }

}
